<template>
  <div class="company base-pad">
    <div class="title">
      <img :src="zh_en == 'zh' ? STATICURL + bgimg.company_bgimg : STATICURL + company_bgimg_en"
        style="width: 100%;height: 100%;" alt="">

    </div>


    <div class="content">
      <img src="../static/images/conpanyBack.png" style="height: 100%; position: absolute;top: 0;left: 0;" alt="">

      <div class="detail">
        <div class="titlebox">
          <div style="color: #8a2e26;font-size: 28px;font-weight: bold;"> {{ zh_en == 'zh' ? '企业动态' : 'Dynamic' }}</div>
          <div style="display: flex;">
            <div class="default" :class='activityIndex == index ? "activity" : ""' v-for="(item, index) in tabList"
              :key="index" @click="change(index)">{{ item }}</div>
          </div>

          <img src="@/static/images/cultureTitile.png" style="width: 100%;position: absolute;bottom: 0;left: 0;"
            mode="widthFix" />
        </div>

        <div class="contentbox" v-if="isShowList">
          <div
            style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-bottom: 24px;">
            <div style="color: #181818; font-size: 28px;font-weight: 600;margin-bottom: 5px;margin-top: 15px;">{{
              tabList[activityIndex] }}</div>
            <div style="width: 82px;height: 7px;border-radius: 3px;background-color: #8a2e26;"></div>
          </div>




          <div v-if="activityIndex == 0"
            style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-between;position: relative;">
            {{ dynamics_list.data }}
            <div style="width: 48%;display: flex;margin-bottom: 20px;" v-for="(item, index) in dynamics_list"
              :key="index" @click="goDetail(item.id)">
              <img :src="staticUrl + item.image" style="height: 130px;width: 35%;margin-right: 10px;" alt="">
              <div style="flex: 1;">
                <div style="display: flex;justify-content: space-between;">
                  <div><span style="font-size: 24px;color: #8a2e26;"> {{ item.year }} </span>{{ item.md }}</div>
                  <div style="font-size: 26px;">></div>
                </div>
                <div style="font-size: 22px;font-weight: 600;color: #8a2e26;margin: 5px 0;text-align: left;">
                  {{ item.title }}
                </div>
                <div style="color: #aaa;text-align: left;">
                  {{ item.abstract }}
                </div>
              </div>
            </div>
            <div style="position: absolute;bottom: -40px; left: 0;right: 0;margin: auto;">
              <el-pagination background layout="prev, pager, next" :total="total" :page-size="6"
                @current-change="currentChange">
              </el-pagination>
            </div>
          </div>
          <div v-if="activityIndex == 1">

            <div v-for="(item, index) in dynamic_notice_list" :key="index" style="display: flex;margin: 20px 0;"
              @click="get_dynamic_notice_info(item.id)">
              <div
                style="width: 76px;height: 76px;display: flex;align-items: center;justify-content: center;border: 1px solid rgba(187,187,187,1);flex-direction: column;margin-right: 10px;">

                <div style="font-size: 18px;font-weight: 600;margin-bottom: 5px;">{{ item.day }}</div>
                <div style="font-size: 15px;color: #ccc;">{{ item.ym }}</div>
              </div>

              <div
                style="flex: 1;text-align: left;display: flex;align-items: center;justify-content: center;flex-direction: column;">
                <div style="font-size: 18px;font-weight: 600;width: 100%;margin-bottom: 5px;">{{ item.title }}</div>
                <div class="ellipsis">{{ item.abstract }}</div>
              </div>
            </div>

            <div style="position: absolute;bottom: -40px; left: 0;right: 0;margin: auto;">
              <el-pagination background layout="prev, pager, next" :total="total" :page-size="6"
                @current-change="currentChange">
              </el-pagination>
            </div>

          </div>
          <div v-if="activityIndex == 2" style="display: flex;flex-wrap: wrap;width: 100%;">

            <div style="width: 32%;margin-right: 1%;" v-for="(item, index) in dynamic_journal_list" :key="index"
              @click="godynamic_journal_info(item.id)">
              <img :src="staticUrl + item.image" alt="" style="width: 100%;height: 160px;margin-bottom: 15px;">
              <div style="text-align: left;">{{ item.title }}</div>
            </div>


            <div style="position: absolute;bottom: -40px; left: 0;right: 0;margin: auto;">
              <el-pagination background layout="prev, pager, next" :total="total" :page-size="6"
                @current-change="currentChange">
              </el-pagination>
            </div>

          </div>
        </div>

        <div class="contentbox" v-if="isShowList == false && activityIndex == 0">
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 30px;">
            <div style="font-size: 30px;font-weight: 600;">
              {{ dynamics_info.title }}
            </div>
            <div style="color: #ccc; font-size: 14px;">发布日期 : {{ dynamics_info.releasetime }}</div>
            <div @click="bcakList"
              style="background-color: rgba(138,46,38,0.05);color: rgba(138,46,38,1);font-size: 14px;border-radius: 5px;width: 120px;height: 40px;line-height: 40px;border: 1px solid rgba(138,46,38,1);">
              返回列表</div>
          </div>
          <div
            style=" width: 60px;background-color: rgba(255,255,255,1);border: 5px solid rgba(138,46,38,1);margin-bottom: 30px;;border-radius: 5px;margin-top: 10px;">
          </div>
          <div v-html="dynamics_info.content">

          </div>
        </div>
        <div class="contentbox" v-if="isShowList == false && activityIndex == 1">
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 30px;">
            <div style="font-size: 30px;font-weight: 600;">
              {{ notice_info.title }}
            </div>
            <div style="color: #ccc; font-size: 14px;">发布日期 : {{ notice_info.releasetime }}</div>
            <div @click="bcakList"
              style="background-color: rgba(138,46,38,0.05);color: rgba(138,46,38,1);font-size: 14px;border-radius: 5px;width: 120px;height: 40px;line-height: 40px;border: 1px solid rgba(138,46,38,1);">
              返回列表</div>
          </div>
          <div
            style=" width: 60px;background-color: rgba(255,255,255,1);border: 5px solid rgba(138,46,38,1);margin-bottom: 30px;;border-radius: 5px;margin-top: 10px;">
          </div>
          <div v-html="notice_info.content">

          </div>
        </div>
        <div class="contentbox" v-if="isShowList == false && activityIndex == 2">
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 30px;">
            <div style="font-size: 30px;font-weight: 600;">
              {{ journal_info.title }}
            </div>
            <div style="color: #ccc; font-size: 14px;">{{ zh_en == 'zh' ? 'Release Date' : 'back list' }}: {{
              journal_info.releasetime }}</div>
            <div @click="bcakList"
              style="background-color: rgba(138,46,38,0.05);color: rgba(138,46,38,1);font-size: 14px;border-radius: 5px;width: 120px;height: 40px;line-height: 40px;border: 1px solid rgba(138,46,38,1);">
              {{ zh_en == 'zh' ? '返回列表' : 'back list' }}</div>
          </div>
          <div
            style=" width: 60px;background-color: rgba(255,255,255,1);border: 5px solid rgba(138,46,38,1);margin-bottom: 30px;;border-radius: 5px;margin-top: 10px;">
          </div>
          <div v-html="journal_info.content">

          </div>
        </div>
      </div>
    </div>

    <!-- journal_info -->
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter.vue';
import {
  get_dynamics_list,
  get_dynamics_info,
  get_dynamic_notice_list,
  get_dynamic_notice_info,
  get_dynamic_journal_list,
  get_dynamic_journal_info
} from "@/api/api";
export default {
  data() {
    return {
      tabList: this.zh_en == 'zh' ? ['企业动态', '集团公告', '成员期刊'] : ['Dynamic', 'Announcement', 'Journals'],
      activityIndex: 0,
      dynamics_list: [],
      dynamic_notice_list: [],
      notice_info: '',
      dynamics_info: '',
      journal_info: '',
      dynamic_journal_list: [],
      staticUrl: this.STATICURL,
      isShowList: true,
      total: 0,
      postData: {
        page: 1,
        per_page: 6
      }
    }
  },
  components: {
    HomeFooter
  },
  mounted() {
    this.change(0)
  },
  methods: {
    currentChange(e) {
      this.postData.page = e
      if (this.activityIndex == 0) {
        this.get_dynamics_list()
      }
      if (this.activityIndex == 1) {
        this.get_dynamic_notice_list()
      }
      if (this.activityIndex == 2) {
        this.get_dynamic_journal_list()()
      }
    },
    goDetail(id) {
      this.isShowList = false;
      console.log(this.isShowList);
      get_dynamics_info({
        id: id
      }).then(res => {
        this.dynamics_info = res
      })
    },
    get_dynamic_journal_list() {
      get_dynamic_journal_list(this.postData).then((res) => {
        this.dynamic_journal_list = res.data
        this.total = res.total
      })
    },
    get_dynamic_notice_info(id) {
      this.isShowList = false;
      console.log('公告');
      get_dynamic_notice_info({
        id: id
      }).then(res => {
        this.notice_info = res
      })
    },
    godynamic_journal_info(id) {
      this.isShowList = false;
      get_dynamic_journal_info({
        id: id
      }).then(res => {
        this.journal_info = res
      })
    },
    get_dynamic_notice_list() {
      get_dynamic_notice_list(this.postData).then((res) => {
        this.dynamic_notice_list = res.data
        this.total = res.total
      })
    },
    bcakList() {
      this.isShowList = true
    },
    get_dynamics_list() {
      get_dynamics_list(this.postData).then((res) => {
        this.dynamics_list = res.data
        this.total = res.total
      })
    },
    change(e) {
      this.activityIndex = e
      this.postData.page = 1
      this.isShowList = true
      if (e == 0) {
        this.get_dynamics_list()
      }
      if (e == 1) {
        this.get_dynamic_notice_list()
      }
      if (e == 2) {
        this.get_dynamic_journal_list()
      }
    }
  }

}
</script>


<style lang="less" scoped>
.contentbox {
  position: relative;
}

.default {
  font-size: 15px;
  padding: 2px 0;
  display: flex;
  align-items: center;
  margin-left: 35px;
}

.activity {
  font-size: 17px;
  color: #8A2E26;
  border-bottom: 1px solid #8A2E26;
}

.content {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  .detail {
    .titlebox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding-bottom: 30px;
    }

    width: 60%;
    margin: 0 auto;
  }
}

.company {}

.title {
  width: 100%;
  height: 360px;
  background-color: #d3dce6;

}
</style>